import { GentuLogo } from "@vitality-ds/icons";
import { CircleAlert, CircleCheck, Info, TriangleAlert } from "lucide-react";
// eslint-disable-next-line import/prefer-default-export
export var DEFAULT_CONTENT = {
  success: {
    icon: CircleCheck,
    title: "Success",
    titleColor: "$colors$success10",
    spinnerColor: "success",
    iconColor: "$colors$success10"
  },
  info: {
    icon: Info,
    title: "Information",
    titleColor: "$colors$info10",
    spinnerColor: "info",
    iconColor: "$colors$info10"
  },
  warning: {
    icon: TriangleAlert,
    title: "Warning",
    titleColor: "$colors$warning10",
    spinnerColor: "warning",
    iconColor: "$colors$warning10"
  },
  critical: {
    icon: CircleAlert,
    title: "Critical",
    titleColor: "$colors$critical10",
    spinnerColor: "critical",
    iconColor: "$colors$critical10"
  },
  accent: {
    icon: Info,
    title: "Information",
    titleColor: "$colors$accent10",
    spinnerColor: "accent",
    iconColor: "$colors$accent10"
  },
  brand: {
    icon: GentuLogo,
    title: "Brand",
    titleColor: "$colors$brand10",
    spinnerColor: "brand",
    iconColor: "$colors$brand10"
  },
  primary: {
    icon: Info,
    title: "Information",
    titleColor: "$colors$primary10",
    spinnerColor: "primary",
    iconColor: "$colors$primary10"
  },
  neutral: {
    icon: Info,
    title: "Information",
    titleColor: "$colors$neutral12",
    spinnerColor: "neutral",
    iconColor: "$colors$neutral12"
  }
};